import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const LINKS = [
  { label: 'Le cheminement', href: '#process' },
  { label: 'Qui suis-je ?', href: '#about' },
  { label: 'FAQ', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? 'backdrop-blur-xl bg-[#f9f2e0]/90 border-b border-[#1c1811]/20'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <nav className="max-w-[1200px] mx-auto flex items-center justify-between px-6 md:px-8 py-4">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-serif tracking-tight text-[#1c1811] leading-none flex flex-col"
        >
          <span className="text-[9px] md:text-[10px] uppercase tracking-[0.25em] text-[#a1802f] mb-1 font-sans">
            Académie
          </span>
          <span className="text-xl md:text-2xl leading-none">
            Conseils <span className="text-[#D90429]">&amp;</span> Réussites
          </span>
        </a>

        <div className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace('#', '').replace(/[^a-z]/gi, '')}`}
              className="text-xs text-[#1c1811]/55 hover:text-[#a1802f] transition-colors duration-300 uppercase tracking-[0.15em]"
            >
              {l.label}
            </a>
          ))}
        </div>

        <a
          href="https://calendly.com/contact-conseils-et-reussites-academie/entretien-prive-clarte" target="_blank" rel="noopener noreferrer"
          data-testid="nav-cta"
          className="group inline-flex items-center gap-2 bg-[#d4a94a] hover:bg-[#b3892f] px-5 py-2.5 text-xs uppercase tracking-[0.15em] text-[#1c1811] transition-colors duration-300"
        >
          Prendre RDV
          <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
            &rarr;
          </span>
        </a>
      </nav>
    </motion.header>
  );
}
